import getPointerStyles from '../../getPointerStyles';
import initialPopperStyles from '../../../../utils/positioner/initialStyles';
var popupContentStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables,
        rtl = _ref.rtl;
    return Object.assign({
      border: "".concat(v.borderSize, " solid ").concat(v.borderColor),
      borderRadius: v.borderRadius,
      background: v.backgroundColor,
      color: v.color,
      boxShadow: v.boxShadow,
      display: 'block',
      textAlign: 'left',
      zIndex: v.zIndex
    }, initialPopperStyles, {}, p.pointing && getPointerStyles(v.pointerOffset, v.pointerGap, v.pointerMargin, rtl, p.placement).root);
  },
  pointer: function pointer(_ref2) {
    var p = _ref2.props,
        v = _ref2.variables,
        rtl = _ref2.rtl;
    return Object.assign({
      display: 'block',
      position: 'absolute',
      backgroundColor: 'inherit',
      borderBottom: "".concat(v.borderSize, " solid ").concat(v.borderColor),
      borderRight: "".concat(v.borderSize, " solid ").concat(v.borderColor),
      height: v.pointerSize,
      width: v.pointerSize
    }, getPointerStyles(v.pointerOffset, v.pointerGap, v.pointerMargin, rtl, p.placement).pointer);
  },
  content: function content(_ref3) {
    var v = _ref3.variables;
    return {
      display: 'block',
      padding: v.padding
    };
  }
};
export default popupContentStyles;